/**
 * Names of fields that can be rendered by the Member Sign In Form Field component.
 */
export var MemberSignInFormFieldName;
(function (MemberSignInFormFieldName) {
    /**
     * The Identifier field renders an input for the member's username or email address.
     */
    MemberSignInFormFieldName["Identifier"] = "Identifier";
    /**
     * The Password field renders an input for the member's password.
     */
    MemberSignInFormFieldName["Password"] = "Password";
    /**
     * The Remember field renders a checkbox for selecting whether to stay signed in.
     */
    MemberSignInFormFieldName["Remember"] = "Remember";
    /**
     * The Captcha field renders a captcha for security purposes.
     */
    MemberSignInFormFieldName["Captcha"] = "Captcha";
})(MemberSignInFormFieldName || (MemberSignInFormFieldName = {}));
//# sourceMappingURL=name.js.map